import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * Component to display dimensions information for a listing.
 * Shows dimensions in the primary unit with conversions.
 */
const SectionDimensionsMaybe = props => {
  const { publicData } = props;

  if (!publicData) {
    return null;
  }

  const { width, height, dimensionUnit, dimensions: dimensionsText } = publicData;
  const hasStructuredDimensions = width && height && dimensionUnit;

  // Fall back to the freeform `dimensions` text field if structured fields aren't set
  if (!hasStructuredDimensions && !dimensionsText) {
    return null;
  }

  // Format structured dimensions with both units
  const formatDimensions = () => {
    const widthNum = parseFloat(width);
    const heightNum = parseFloat(height);

    const convertedWidth = dimensionUnit === 'inches'
      ? (widthNum * 2.54).toFixed(1)
      : (widthNum / 2.54).toFixed(1);
    const convertedHeight = dimensionUnit === 'inches'
      ? (heightNum * 2.54).toFixed(1)
      : (heightNum / 2.54).toFixed(1);

    const primarySymbol = dimensionUnit === 'inches' ? '"' : 'cm';
    const secondarySymbol = dimensionUnit === 'inches' ? 'cm' : '"';

    return `${widthNum}${primarySymbol} × ${heightNum}${primarySymbol} (${convertedWidth}${secondarySymbol} × ${convertedHeight}${secondarySymbol})`;
  };

  const dimensionsDisplay = hasStructuredDimensions ? formatDimensions() : dimensionsText;

  return (
    <section className={css.sectionDetails}>
      <p className={css.inlineDetailRow}>
        <span className={css.sectionHeading}>
          <FormattedMessage id="ListingPage.dimensionsTitle" />
        </span>
        <span className={css.inlineDetailValue}>{dimensionsDisplay}</span>
      </p>
    </section>
  );
};

export default SectionDimensionsMaybe;
